/**
 * messages - 공통 토스트·안내 문구 단일 출처. create/update 모두 "저장되었습니다."로 통일한다.
 * 문구 원본은 locales/{언어}/common.json 이고, 여기서는 접근 시점의 언어로 읽어 준다(getter).
 */
import { i18n } from '@/locales';

export const MSG = {
  get SAVED() {
    return i18n.global.t('common.msg.saved');
  },
  get DELETED() {
    return i18n.global.t('common.msg.deleted');
  },
  get NO_CHANGES() {
    return i18n.global.t('common.msg.noChanges');
  },
  // 메뉴 권한이 없는 화면 주소로 들어왔을 때
  get NO_SCREEN_PERMISSION() {
    return i18n.global.t('common.msg.noScreenPermission');
  },
  // 등록되지 않은 주소로 들어왔을 때
  get SCREEN_NOT_FOUND() {
    return i18n.global.t('common.msg.screenNotFound');
  },
  // 새로 불러온 뒤에도 화면 파일을 받지 못했을 때
  get SCREEN_LOAD_FAILED() {
    return i18n.global.t('common.msg.screenLoadFailed');
  },
  // 화면 코드에서 처리하지 못한 오류
  get SCREEN_ERROR() {
    return i18n.global.t('common.msg.screenError');
  },
  // 서버 목록 상한에 걸려 잘렸을 때(meta.truncated)
  listTruncated(n) {
    return i18n.global.t('common.msg.listTruncated', { n: Number(n).toLocaleString() });
  },
};
